import React, { Component } from 'react';
import { Modal, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import FormList from '../../basicElement/FormList';

class AdjustAmountModal extends Component {
    state = {
        visible: false,
        record: {},
        params: {},
        loading: false,
    }

    show = record => {
        const { 
            jdeApplyId, 
            initialExpectContractAmount, 
            expectContractAmount, 
            exchangeRate, 
            currency
        } = record;
        const isCNY = currency == '人民币(CNY)';

        this.setState({
            record,
            visible: true,
            params: {
                jdeApplyId,
                initialExpectContractAmount,
                expectContractAmount: isCNY ? expectContractAmount : (!!initialExpectContractAmount || initialExpectContractAmount === 0) ? String(expectContractAmount) : undefined,
                exchangeRate,
            },
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            record: {},
            params: {},
            loading: false,
        });
    }

    handleSubmit = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;
        const { params, params: { fileList } } = this.state;
        const fileMetaIds = fileList.map(file => file.response.fileMetaId);
        params.ids = fileMetaIds;
        delete params.fileList;
        const options = {
            url: API_URL.contract.changeExpectContractAmount,
            data: params,
            dataType: 'json',
            doneResult: res => {
                if (res.error) {
                    message.error(res.error);
                } else {
                    message.success(res.success);
                    this.hide();
                    this.props.loadData();
                }
            }
        };
        
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        if(key == 'initialExpectContractAmount'){
            params.expectContractAmount = value || value === 0 ? (value * params.exchangeRate).toFixed(2) : '';
        }
        this.setState({
            params,
            hasEdit: true,
        });
    }

    getColumns = () => {
        const { record, params } = this.state;
        const { currency } = record;
        const isCNY = currency == '人民币(CNY)';
        
        const columns = [{
            name: '汇率',
            key: 'exchangeRate',
            type: 'text',
            rules: {
                display: !isCNY,
            }
        },  {
            name: '预计合同金额/原币',
            key: 'initialExpectContractAmount',
            type: 'inputNumber',
            typeProperty: {
                min: 0,
                precision: 2,
                style: {
                    width: '200px',
                },
            },
            rules: {
                required: true,
                display: !isCNY,
            }
        },  {
            name: '预计合同金额/人民币（元）',
            key: 'expectContractAmount',
            type: isCNY ? 'inputNumber' : 'text',
            typeProperty: {
                min: 0,
                precision: 2,
                style: {
                    width: '200px',
                }
            },
            rules: {
                required: true,
            }
        },{
            name: '上传附件',
            key: 'fileList',
            type: 'upload',
            rules: {
                required: true,
            },
            typeProperty: {
                uploadUrl: API_URL.evaluate.uploadEnclosureFile,
                removeUrl: API_URL.contract.deleteJdeCodeEnclosure,
                params: {
                    curUserId: sessionStorage.userId,
                    curEmployeeCode: sessionStorage.curEmployeeCode || '',
                    uploadType: 'ADVANCE_WORK',
                    path: Date.now(),
                    relateId: '',
                },
            }
        }, ];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, children, rules = {} } = column;
                if (children) {
                    traverseColumns(children);
                } else {
                    const typeProperty = column.typeProperty || (column.typeProperty = {});
                    typeProperty.canEdit = true;
                    typeProperty.value = params[key];
                }
            });
        }
        traverseColumns(columns);


        return columns;
    }

    render() {
        const { visible } = this.state;
        return (
            <Modal
                title="预计合同金额调整"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="condition-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width={500}
            >
                <FormList
                    className="form-list registerStartUp-list"
                    columns={this.getColumns()}
                    onChange={this.handleChange}
                    ref={el => this.formRef = el}
                />
        </Modal>
        )
    }
}

export default AdjustAmountModal;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/AdjustAmountModal.js